import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { SubsidyState, RootState } from '../types';

const namespaced: boolean = true;

export const state: SubsidyState = {
	subsidies: []
};

export const Subsidies: Module<SubsidyState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default Subsidies;